import { Form } from '@/shared/ui'

export const TaxInvoiceFields = () => {
  return (
    <div className="space-y-3">
      <Form.Field name="corpId">
        <Form.Label bold>사업자 등록번호</Form.Label>
        <Form.TextField
          type="number"
          placeholder="사업자 등록번호는 ‘-’없이 숫자만 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="corpName">
        <Form.Label bold>사업자명</Form.Label>
        <Form.TextField
          type="text"
          placeholder="사업자명을 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="corpCeo">
        <Form.Label bold>대표자 이름</Form.Label>
        <Form.TextField
          type="text"
          placeholder="대표자 이름을 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="invoiceeEmail" className="flex-grow">
        <Form.Label bold>이메일 주소 (선택)</Form.Label>
        <Form.TextField
          type="email"
          placeholder="이메일 주소를 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>
    </div>
  )
}
